import { IResponseBaseTDto } from "@sprytki-frontend-apps/common";
import { apiClient } from "./apiClient";

const ALARM_ZONES = 'alarmZones';

export const ZoneServiceAPI = {
	arm: async (id: string): Promise<IResponseBaseTDto<boolean>> => {
		const response = await apiClient.post(`${ALARM_ZONES}/${id}/arm`);
		return response.data;
	},
	disarm: async (id: string): Promise<IResponseBaseTDto<boolean>> => {
		const response = await apiClient.post(`${ALARM_ZONES}/${id}/disarm`);
		return response.data;
	}
};
